import { useMutation } from "@tanstack/react-query";
import { axiosCoreInstance } from "src/config/axios";
import { CompanyUserModel } from "../../types/CompanyUser";

export interface UserInvitationAcceptRequest {
    invitationId?: number;
}

interface OwnProps {
    onSuccess?: () => void;
}

export const useUserInvitationAcceptMutation = ({ onSuccess }: OwnProps) => {
    return useMutation(
        async (values: UserInvitationAcceptRequest) => {
            if (values.invitationId) {
                const { data }: { data: CompanyUserModel } = await axiosCoreInstance.post(
                    `api/user/invitation/${values.invitationId}`
                );
                return data;
            }
            return null;
        },
        {
            onSuccess: () => {
                if (onSuccess) {
                    onSuccess();
                }
            },
        }
    );
};
